// One sale, Overview (docs/SALES-ACCESS.md). The page reads its own record by id, so a shared link opens it cold.
import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SalesAccessSaleRoute } from '../modules/venue-port/tkt/SalesAccessRoutes';

export const Route = createFileRoute('/sales-access/$id/')({
  component: function SalesAccessOverview() {
    const { id } = Route.useParams();
    return <SalesAccessSaleRoute salesAccessId={id} tab="overview" />;
  },
});
